// extracted by mini-css-extract-plugin
export var growableInput = "_76-0";
export var tagContainer = "_76-2";
export var textInput = "_76-1";